import { linkStrategy } from '@/App.datalayer';

import { OnDatalayerProps } from '../HOCs/withGTM.interface';

export const onDatalayer = ({ target }: OnDatalayerProps) => {
  return linkStrategy({ target, position: 'message_bar' });
};
